<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="beforeData">
        <div class="grid-content">
          <div class="title">变更前</div>
          <div class="title-box" v-if="beforeData.registrationPO && beforeData.registrationPO.num"><span class="txt1">凭证信息</span></div>
          <div class="item" v-if="beforeData.registrationPO && beforeData.registrationPO.num">凭证编号：{{beforeData.registrationPO.num}}</div>
          <template v-if="getPayPO(beforeData)">
            <div class="title-box"><span class="txt1">付款信息</span></div>
            <div class="bank-box">
              <div class="item" v-if="getPayPO(beforeData).payImg">
                付款图片：
                <el-image style="width: 80px; height: 80px" :src="getPayPO(beforeData).payImg" :preview-src-list="[getPayPO(beforeData).payImg]"></el-image>
              </div>
              <div class="item">付款单号：{{getPayPO(beforeData).payNum}}</div>
              <div class="item">金额：{{getPayPO(beforeData).payMoney}}</div>
              <div class="item">银行名字：{{getPayPO(beforeData).payBank}}</div>
              <div class="item">支付时间：{{formatDateTime(getPayPO(beforeData).payTime)}}</div>
              <div class="item">操作时间：{{formatDateTime(getPayPO(beforeData).createdTime)}}</div>
            </div>
          </template>
          <template v-else-if="(beforeData.payPOList || []).length">
            <div class="title-box"><span class="txt1">付款信息</span></div>
            <div class="bank-box" v-for="(p,idx) in (beforeData.payPOList || [])" :key="idx">
              <div class="item" v-if="p.payImg">
                付款图片：
                <el-image style="width: 80px; height: 80px" :src="p.payImg" :preview-src-list="[p.payImg]"></el-image>
              </div>
              <div class="item">付款单号：{{p.payNum}}</div>
              <div class="item">金额：{{p.payMoney}}</div>
              <div class="item">银行名字：{{p.payBank}}</div>
              <div class="item">支付时间：{{formatDateTime(p.payTime)}}</div>
              <div class="item">操作时间：{{formatDateTime(p.createdTime)}}</div>
            </div>
          </template>
          <pre v-if="!hasKnownBefore" class="json-view">{{ pretty(form.beforeStr) }}</pre>
        </div>
      </el-col>
      <el-col :span="12" v-if="afterData">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <div class="title-box" v-if="afterData.registrationPO && afterData.registrationPO.num"><span class="txt1">凭证信息</span></div>
          <div class="item" v-if="afterData.registrationPO && afterData.registrationPO.num">凭证编号：{{afterData.registrationPO.num}}</div>
          <template v-if="getPayPO(afterData)">
            <div class="title-box"><span class="txt1">付款信息</span></div>
            <div class="bank-box">
              <div class="item" v-if="getPayPO(afterData).payImg">
                付款图片：
                <el-image style="width: 80px; height: 80px" :src="getPayPO(afterData).payImg" :preview-src-list="[getPayPO(afterData).payImg]"></el-image>
              </div>
              <div class="item">付款单号：{{getPayPO(afterData).payNum}}</div>
              <div class="item">金额：{{getPayPO(afterData).payMoney}}</div>
              <div class="item">银行名字：{{getPayPO(afterData).payBank}}</div>
              <div class="item">支付时间：{{formatDateTime(getPayPO(afterData).payTime)}}</div>
              <div class="item">操作时间：{{formatDateTime(getPayPO(afterData).createdTime)}}</div>
            </div>
          </template>
          <template v-else-if="(afterData.payPOList || []).length">
            <div class="title-box"><span class="txt1">付款信息</span></div>
            <div class="bank-box" v-for="(p,idx) in (afterData.payPOList || [])" :key="idx">
              <div class="item" v-if="p.payImg">
                付款图片：
                <el-image style="width: 80px; height: 80px" :src="p.payImg" :preview-src-list="[p.payImg]"></el-image>
              </div>
              <div class="item">付款单号：{{p.payNum}}</div>
              <div class="item">金额：{{p.payMoney}}</div>
              <div class="item">银行名字：{{p.payBank}}</div>
              <div class="item">支付时间：{{formatDateTime(p.payTime)}}</div>
              <div class="item">操作时间：{{formatDateTime(p.createdTime)}}</div>
            </div>
          </template>
          <pre v-if="!hasKnownAfter" class="json-view">{{ pretty(form.afterStr) }}</pre>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  computed: {
    beforeData() {
      if (!this.form || !this.form.beforeStr) return null
      const b = typeof this.form.beforeStr === 'string' 
        ? JSON.parse(this.form.beforeStr) 
        : this.form.beforeStr
      return b
    },
    afterData() {
      if (!this.form || !this.form.afterStr) return null
      const a = typeof this.form.afterStr === 'string' 
        ? JSON.parse(this.form.afterStr) 
        : this.form.afterStr
      return a
    },
    hasKnownBefore() {
      const b = this.beforeData
      if (!b) return false
      const hasVoucher = b.registrationPO && b.registrationPO.num
      const hasPayPO = b.customerRegistrationPayPO || b.CustomerRegistrationPayPO
      const hasPays = Array.isArray(b.payPOList) && b.payPOList.length > 0
      return hasVoucher || hasPayPO || hasPays
    },
    hasKnownAfter() {
      const a = this.afterData
      if (!a) return false
      const hasVoucher = a.registrationPO && a.registrationPO.num
      const hasPayPO = a.customerRegistrationPayPO || a.CustomerRegistrationPayPO
      const hasPays = Array.isArray(a.payPOList) && a.payPOList.length > 0
      return hasVoucher || hasPayPO || hasPays
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;
      })
    },
    getPayPO(data) {
      if (!data) return null
      return data.customerRegistrationPayPO || data.CustomerRegistrationPayPO || null
    },
    formatDateTime(dateTime) {
      if (!dateTime) return ''
      // 将 ISO 8601 格式中的 T 替换为空格，并移除毫秒和时区信息
      return String(dateTime).replace('T', ' ').replace(/\.\d{3}Z?$/, '').replace(/Z$/, '')
    },
    pretty(obj) {
      try {
        return JSON.stringify(obj, null, 2)
      } catch (e) {
        return String(obj)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.json-view {
  background: #fafafa;
  padding: 8px 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  max-height: 360px;
  overflow: auto;
}
.title-box { margin: 10px 0 6px; }
.bank-box { padding: 6px 0; border-bottom: 1px dashed #eee; }
.item { line-height: 22px; }
</style>
